import React, { useEffect } from 'react';
import { useUnit } from 'effector-react';
import mapboxgl from 'mapbox-gl';
import { $mapLoaded } from '../../models/mapModel/index.js';
import attracts from '../../data/public_attracts.json';
import { changeLayerVisibility } from '../../utils/mapbox-utils.js';
import { $attractLayer } from '../../models/zoom7Model/index.js';
import { $isPreset } from '../../models/rbpLiteModel/index.js';

const icons_dict = {
  БЦ: 'bc',
  ТЦ: 'tc',
  ТРЦ: 'trc',
};

const days_translation = {
  Fri: 'Пятница',
  Mon: 'Понедельник',
  Thu: 'Четверг',
  Tue: 'Вторник',
  Wed: 'Среда',
  Sat: 'Суббота',
  Sun: 'Воскресенье',
};

const makeSchedule = (schedule) => {
  const translationNOrder = {
    Mon: 'Пн',
    Tue: 'Вт',
    Wed: 'Ср',
    Thu: 'Чт',
    Fri: 'Пт',
    Sat: 'Сб',
    Sun: 'Вс',
  };

  return Object.entries(schedule)
    .sort((a, b) => {
      return (
        Object.keys(translationNOrder).indexOf(a[0]) -
        Object.keys(translationNOrder).indexOf(b[0])
      );
    })
    .map((item) => {
      return `
        <div>
          ${translationNOrder[item[0]]}: ${item[1].working_hours[0].from} -
          ${item[1].working_hours[0].to}
        </div>
      `;
    });
};

const onClick = (e) => {
  const feature = e.features[0];
  const coordinates = feature.geometry.coordinates.slice();

  // const schedule_source = JSON.parse(feature.properties.schedule);
  // if (schedule_source.is_24x7) delete schedule_source.is_24x7;
  // if (schedule_source.comment) delete schedule_source.comment;
  // const schedule = Object.fromEntries(
  //   Object.keys(schedule_source).map((item) => {
  //     return [
  //       item,
  //       Object.values(schedule_source[item].working_hours[0]).join(' - '),
  //     ];
  //   })
  // );

  const html = `
            <div class="popup_content_wrapper">
              <div class="popup_item_wrapper popup_item_even">
                <div class="popup_item_field">Название:</div> 
                <div class="popup_item_value">${
                  feature.properties.name || '-'
                }</div>
              </div>
             <div class="popup_item_wrapper popup_item_odd">
                <div class="popup_item_field">График работы:</div> 
                <div class="popup_item_value">${
                  feature.properties.schedule.length > 0
                    ? makeSchedule(
                        JSON.parse(feature.properties.schedule)
                      ).join('')
                    : '-'
                }</div>
              </div>
            </div>`;

  // <div className="popup_item_wrapper popup_item_odd">
  //   <div className="popup_item_field">Расписание:</div>
  //   <div className="popup_item_value">
  //     <div>${days_translation.Mon} : ${schedule.Mon || '-'}</div>
  //     <div>${days_translation.Tue} : ${schedule.Tue || '-'}</div>
  //     <div>${days_translation.Wed} : ${schedule.Wed || '-'}</div>
  //     <div>${days_translation.Thu} : ${schedule.Thu || '-'}</div>
  //     <div>${days_translation.Fri} : ${schedule.Fri || '-'}</div>
  //     <div>${days_translation.Sun} : ${schedule.Sun || '-'}</div>
  //     <div>${days_translation.Sat} : ${schedule.Sat || '-'}</div>
  //   </div>

  new mapboxgl.Popup().setLngLat(coordinates).setHTML(html).addTo(window.map);
};

function PublicAttracts() {
  const mapLoaded = useUnit($mapLoaded);
  const attractLayer = useUnit($attractLayer);
  const isPreset = useUnit($isPreset);

  const createLayer = (update) => {
    const attractsData = {
      type: 'FeatureCollection',
      features: attractLayer
        ? attracts.features.filter(
            (item) => item.properties.type === attractLayer
          )
        : attracts.features,
    };

    if (update) {
      window.map.getSource('public_attracts_source').setData(attractsData);
      window.map.setLayoutProperty(
        'public_attracts_layer',
        'icon-image',
        icons_dict[attractLayer]
      );
    } else {
      if (!window.map.getSource('public_attracts_source')) {
        window.map.addSource('public_attracts_source', {
          type: 'geojson',
          data: attractsData,
        });
      }

      if (!window.map.getLayer('public_attracts_layer')) {
        window.map.addLayer({
          id: 'public_attracts_bg_layer',
          type: 'circle',
          source: 'public_attracts_source',
          paint: {
            'circle-color': 'white',
            'circle-radius': 13,
          },
        });
        window.map.addLayer({
          id: 'public_attracts_layer',
          type: 'symbol',
          source: 'public_attracts_source',
          layout: {
            'icon-size': 2,
            'icon-allow-overlap': true,
          },
        });
      }

      window.map.on('click', 'public_attracts_layer', onClick);

      changeLayerVisibility('public_attracts_layer', false);
      changeLayerVisibility('public_attracts_bg_layer', false);
    }
  };

  useEffect(() => {
    if (mapLoaded && attracts) {
      if (window.map.getLayer('public_attracts_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, attracts, attractLayer]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('public_attracts_layer')) {
      if (attractLayer) {
        changeLayerVisibility('public_attracts_layer', true);
        changeLayerVisibility('public_attracts_bg_layer', true);

        setTimeout(() => {
          window.map.moveLayer(
            'zoom7_hexagon_layer',
            'public_attracts_bg_layer'
          );
          window.map.moveLayer(
            'zoom7_hexagon_outline',
            'public_attracts_bg_layer'
          );
        }, 500);
      } else {
        changeLayerVisibility('public_attracts_layer', false);
        changeLayerVisibility('public_attracts_bg_layer', false);
      }
    }
  }, [mapLoaded, attractLayer]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('public_attracts_layer')) {
      if (isPreset) {
        changeLayerVisibility('public_attracts_layer', false);
        changeLayerVisibility('public_attracts_bg_layer', false);
      } else if (attractLayer) {
        changeLayerVisibility('public_attracts_layer', true);
        changeLayerVisibility('public_attracts_bg_layer', true);

        setTimeout(() => {
          window.map.moveLayer(
            'zoom7_hexagon_layer',
            'public_attracts_bg_layer'
          );
          window.map.moveLayer(
            'zoom7_hexagon_outline',
            'public_attracts_bg_layer'
          );
        }, 500);
      } else {
        changeLayerVisibility('public_attracts_layer', false);
        changeLayerVisibility('public_attracts_bg_layer', false);
      }
    }
  }, [mapLoaded, isPreset, attractLayer]);
  return null;
}

export default PublicAttracts;
